import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface SendEmailRequest {
  SenderName: string;
  SenderEmail: string;
  MobileNumber?: string;
  Message: string;
  Subject?: string;
  CountryId?: string | number;
}

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  public constructor(private http: HttpClient) {}

  public sendEmail(payload: SendEmailRequest): Observable<any> {
    return this.http.post<any>(`https://api-stage.glamera.com/api/Account/ContactUs`, payload);
  }
}


